const getters = {
  processing: (state) => state.processing,
  bulkProcessing: (state) => state.bulkProcessing,
  npses: (state) => state.npses,
};

export default getters;
